import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=5f0c76b0"
import script from "./UserRoles.vue?vue&type=script&lang=ts"
export * from "./UserRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports